import colors from './colors';

export default {
  main: colors,
};
